module.exports = __webpack_public_path__ + "img/interfaces.436f490f.png";